// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__38TMz","box":"WorkspacesBox_box__1_-j0","node":"WorkspacesBox_node__1KvKb"};